<div class="modal-header" appCustomAutofocus>
    <h3>Expired Password Warning</h3>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <label>Your password has expired, please click the link below to change your password.</label>
        </div>
    </div>
    <div class="row" style="margin-top: 12px;">
        <div class="col-md-12">
            <button type="button" class="btn btn-primary" (click)="changePassword()">
                Change Password
            </button>
        </div>
    </div>
</div>